const appConfig: AppConfig = window.APP_CONFIG || {};

export const Configuration = {
  AZNConnectApiUrl: process.env.VUE_APP_AZNCONNECT_API_ROOT || "",
  SignalRUrl: process.env.VUE_APP_SIGNALR_URL || "",
  pastReferralThresholdMinutes:
    appConfig.pastReferralThresholdMinutes != null
      ? appConfig.pastReferralThresholdMinutes
      : -5,
  showArrivalFeatures:
    appConfig.showArrivalFeatures != null
      ? appConfig.showArrivalFeatures
      : false,
  showMessageHistory:
    appConfig.showMessageHistory != null
      ? appConfig.showMessageHistory
      : false,
};
